var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinkHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 102,
    viewBox: "0 0 99 102",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#F66FB4",
    cx: 49.5,
    cy: 52.545,
    rx: 49.5,
    ry: 49.455
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.053 60.922a4.182 4.182 0 0 1 2.19 2.355c.06.16.285.168.355.014a4.199 4.199 0 0 1 2.355-2.193.193.193 0 0 0 .014-.355 4.182 4.182 0 0 1-2.19-2.355.193.193 0 0 0-.355-.014 4.202 4.202 0 0 1-2.355 2.193.193.193 0 0 0-.014.355zM63.874 84.63a7.36 7.36 0 0 1 3.85 4.14c.105.28.502.294.625.023a7.387 7.387 0 0 1 4.141-3.855c.28-.105.294-.502.023-.624a7.36 7.36 0 0 1-3.85-4.14c-.105-.28-.502-.294-.625-.022a7.388 7.388 0 0 1-4.141 3.854c-.28.106-.296.502-.023.625zM11.142 69.88a7.352 7.352 0 0 1 3.85 4.14c.105.28.502.294.625.023a7.387 7.387 0 0 1 4.141-3.855c.28-.106.296-.502.023-.625a7.357 7.357 0 0 1-3.85-4.14c-.105-.278-.502-.293-.625-.022a7.387 7.387 0 0 1-4.141 3.855c-.28.106-.294.502-.023.625z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.473 13.726a1.635 1.635 0 0 0 1.722-1.1l2.517-8.666A1.63 1.63 0 0 0 36.69 1.89a1.638 1.638 0 0 0-2.072 1.023l-2.516 8.667a1.631 1.631 0 0 0 1.365 2.146l.006-.001zM20.515 21.403a1.634 1.634 0 0 0-1.24-1.624l-8.853-1.79a1.633 1.633 0 0 0-1.979 1.189 1.636 1.636 0 0 0 1.192 1.979l8.853 1.789a1.633 1.633 0 0 0 2.028-1.539v-.004zM23.306 15.158a1.633 1.633 0 0 0 1.62-2.39L18.578.864a1.632 1.632 0 0 0-2.882 1.534l6.346 11.904c.263.496.744.8 1.263.856z",
    fill: "#FFD31D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.361 55.382c.015-.051.033-.1.047-.15 2.704-9.483-1.686-20.121-12.01-23.058-8.203-2.334-14.637 2.203-17.83 7.253-.052-5.973-3.13-13.216-11.332-15.55C35.913 20.94 26.573 27.67 23.87 37.154c-.015.05-.026.102-.04.151-.643 2.05-6.576 23.059 20.306 49.209v.004s.003-.002.004 0c.002 0 .003 0 .003.002l.006-.001.003.003.001-.004C80.791 78.441 86.827 57.46 87.36 55.381h.001z",
    fill: "#DE2C87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.036 50.572c.015-.05.033-.1.047-.149 2.703-9.485-1.687-20.122-12.01-23.059-8.203-2.333-14.637 2.203-17.831 7.254-.051-5.973-3.13-13.218-11.331-15.55-10.323-2.938-19.664 3.793-22.367 13.276-.015.051-.026.102-.039.152-.643 2.049-6.576 23.058 20.306 49.208l-.001.004.004-.001c.003 0 .003.002.004.003h.005l.004.003v-.004C78.465 73.63 84.501 52.65 85.035 50.572h.002z",
    fill: "#FFD31D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.946 68.876c2.165 2.876 4.771 5.866 7.912 8.939l-.001.003h.004c.001 0 .003.001.003.003.001 0 .004-.002.004 0l.005.002v-.004c31.02-6.934 36.161-24.806 36.616-26.576.012-.044.027-.085.04-.127.29-1.022.485-2.06.586-3.1-14.323 18.135-33.336 21.087-45.17 20.86zM23.947 33.588s4.102-15.166 21.36-10.45c0 0-12.449-.74-21.36 10.45z",
    fill: "#FFE93B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinkHeart);
export default __webpack_public_path__ + "static/media/pink_heart.eca7c0fee8020e89fe8808ed263c54ff.svg";
export { ForwardRef as ReactComponent };